import {notify} from '../utils';
import * as types from './types';

export default {
  [types.ERROR](context, message) {
    notify(message, 'danger');
  },
  [types.SUCCESS](context, message) {
    notify(message, 'success');
  },
  [types.WARNING](context, message) {
    notify(message, 'warning');
  },
};
